import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatPLN } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Building2, CheckSquare, Wallet, MessageSquareWarning, AlertTriangle } from "lucide-react";

export default function ManagerDashboard() {
  const [summary, setSummary] = useState(null);

  useEffect(() => { api.get("/dashboard/summary").then((r) => setSummary(r.data)); }, []);

  if (!summary) return <div className="text-sm text-slate-500">Ładowanie…</div>;

  return (
    <div>
      <PageHeader testId="manager-dashboard" title="Dashboard kierownika" subtitle="Twoje budowy i oczekujące akcje" />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <Link to="/manager/orders" className="ol-kpi hover:border-[#FF6B1A] transition-colors block" data-testid="kpi-pending-orders">
          <div className="flex items-center gap-2 mb-2 text-slate-500"><CheckSquare className="w-4 h-4" /><p className="text-xs font-semibold uppercase tracking-wide">Zamówienia do akceptacji</p></div>
          <p className="text-3xl font-bold text-slate-900">{summary.pending_orders}</p>
        </Link>
        <Link to="/manager/budget-requests" className="ol-kpi hover:border-[#FF6B1A] transition-colors block" data-testid="kpi-budget-requests">
          <div className="flex items-center gap-2 mb-2 text-slate-500"><Wallet className="w-4 h-4" /><p className="text-xs font-semibold uppercase tracking-wide">Prośby o budżet</p></div>
          <p className="text-3xl font-bold text-slate-900">{summary.pending_budget_requests}</p>
        </Link>
        <Link to="/manager/custom-requests" className="ol-kpi hover:border-[#FF6B1A] transition-colors block" data-testid="kpi-custom-requests">
          <div className="flex items-center gap-2 mb-2 text-slate-500"><MessageSquareWarning className="w-4 h-4" /><p className="text-xs font-semibold uppercase tracking-wide">Produkty spoza katalogu</p></div>
          <p className="text-3xl font-bold text-slate-900">{summary.pending_custom_requests}</p>
        </Link>
      </div>

      <h2 className="text-lg font-semibold text-slate-900 mb-3 flex items-center gap-2"><Building2 className="w-4 h-4" /> Twoje budowy</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {summary.sites?.map((s) => {
          const pct = s.monthly_budget > 0 ? (s.used_budget_current_month / s.monthly_budget) * 100 : 0;
          const over = s.remaining < 0;
          return (
            <div key={s.id} className="ol-card p-5" data-testid={`site-card-${s.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-base font-bold text-slate-900">{s.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">NDI · {s.approval_required_for_all_orders ? "Pełna akceptacja" : `Auto do ${formatPLN(s.auto_approve_limit)}`}</p>
                </div>
                {over && <AlertTriangle className="w-5 h-5 text-red-500" />}
              </div>
              <div className="mt-4">
                <div className="flex justify-between text-xs mb-1.5">
                  <span className="text-slate-500">Wykorzystanie</span>
                  <span className="font-semibold text-slate-900">{formatPLN(s.used_budget_current_month)} / {formatPLN(s.monthly_budget)}</span>
                </div>
                <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                  <div className={`h-full ${pct >= 100 ? "bg-red-500" : pct >= 80 ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${Math.min(pct, 100)}%` }} />
                </div>
                <div className="flex justify-between text-xs mt-1.5">
                  <span className="text-slate-500">Pozostało</span>
                  <span className={`font-semibold ${over ? "text-red-600" : "text-emerald-600"}`}>{formatPLN(s.remaining)}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
